module.exports = __webpack_public_path__ + "static/media/helicopter.9f9b0561.svg";